import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectWebsitesListItems } from "../../../../../redux/websites/selector";
import { websites } from "../../../../../redux/websites/action";
import { websiteCards } from "../../../../../redux/websiteCards/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import storePersist from "../../../../../redux/storePersist";

const ManagementWebsites = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const websitesItems = useSelector(selectWebsitesListItems)
  var tenantId = storePersist?.get("accessTokenMetadata")?.current?.TokenMetadata?.TenantId;


  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const [
    updatedRowData,
    setUpdatedRowData
  ] = useState<any>([]);
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'WebSiteName', headerName: 'WebSiteName', sortable: true, filter: true },
      { field: 'OUName', headerName: 'OrganizationUnit Name' },
      { field: 'HostingUrl', headerName: 'HostingUrl', sortable: false, filter: false, input: true, type: 'text' },
      { field: 'MappedDomain', headerName: 'MappedDomain', sortable: false, filter: false, input: true, type: 'text' },
      { field: 'DisplayOrder', headerName: 'DisplayOrder', sortable: false, filter: false, input: true, type: 'text' },
      {
        field: 'FQDNName', headerName: 'FQDNName', searchField: 'FQDNName', filter: true,
        filterType: 'text', input: true, type: 'text'
      },
      { field: 'Remarks', headerName: 'Remarks' },
      { field: 'TableUrl', headerName: 'Table URL' },
      { field: 'StorageEndpointUrl', headerName: 'Storage End point URL' },
      { field: 'CDNEndpointUrl', headerName: 'CDN End point URL' },

    ]);
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.PlatformWebSiteId}`)
  }

  const handleInputChange = (event: any, field: any, row: any) => {
    const { value } = event.target;
    setUpdatedRowData((prevUser: any) => ({
      ...prevUser,
      [field]: value,
    }));
  };


  const handlereset = async (data: any) => {
    const { PlatformWebSiteId, StoreId, DepartmentId } = data;
    const requestData = {
      PlatformWebSiteId,
      StoreId,
      DepartmentId,
      TenantId: tenantId
    };
    dispatch(websites.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/sync-website-with-platform-website-template`, entity: 'websites', jsonData: {

        Records: [
          {
            "Context": {},
            "Message": {
              ...requestData
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Reset the websites in CDN  successfully')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });

  }

  const handleUpdateWebsite = async (data: any) => {

    dispatch(websiteCards.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/add-new-cards-to-tenant-websites`, entity: 'websiteCards', jsonData: {

        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              PlatformWebSiteId: data?.PlatformWebSiteId,
              StoreId: data?.StoreId,
              DepartmentId: data?.DepartmentId
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Added New Cards to tenant websites from platform websites')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });
  }

  const handleCDNUpdateWebsite = async (data: any) => {

    dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/update`, entity: 'websiteCards', jsonData: {

        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Added New Cards from tenant websites and published in CDN')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });
  }
  const handleCDNResetWebsite = async (data: any) => {

    dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/sync`, entity: 'websiteCards', jsonData: {

        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Reset the tenant websites and published in CDN')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });
  }

  const handleCDNDeleteWebsite = async (data: any) => {

    dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/remove`, entity: 'websiteCards', jsonData: {

        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Delete the tenant Websites details from CDN')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });
  }
  const handleEnableTenantWebsite = async (data: any) => {
    dispatch(websites.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites`, entity: 'websites', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              ...data
            }
          }
        ]

      }
    }))
      .then(() => {

        // toast.info('Tenant Websites you are selected is activated now')
        dispatch(websites.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
            "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              }
            ],

          }
        }))
      });

  }

  const handlePublishTenantWebsite = async (data: any) => {
    dispatch(websiteCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/publish`, entity: 'websiteCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id
            }
          }
        ]

      }
    }))
      .then(() => {
        // toast.info('Tenant Websites you are selected is successfully published in CDN')
        dispatch(websites.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
            "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              }
            ],

          }
        }))
      });

  }

  const handleSave = async (data: any) => {
    dispatch(websites.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites`, entity: 'websites', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              Id: data?.Id,
              TenantId: tenantId,
              PlatformWebSiteId: data?.PlatformWebSiteId,
              StoreId: data?.StoreId,
              DepartmentId: data?.DepartmentId,
              WebSiteName: data?.WebSiteName,
              WebSiteVersionId: data?.WebSiteVersionId,
              HostingUrl: updatedRowData?.HostingUrl || data?.HostingUrl,
              MappedDomain: updatedRowData?.MappedDomain || data?.MappedDomain,
              DisplayOrder: updatedRowData?.DisplayOrder || data?.DisplayOrder,
              FQDNName: updatedRowData?.FQDNName || data?.FQDNName,
              Remarks: data?.Remarks
            }
          }
        ]

      }
    }))
      .then(() => {
        // toast.info('Tenant Websites details are updated Successfully')
        dispatch(websites.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
            "Filters": [
              {
                "FieldName": "TenantId",
                "FilterOperatorId": 1,
                "FieldValue": tenantId,
                "FieldType": "number"
              }
            ],

          }
        }))
      });
    setUpdatedRowData({})
  }
  const handleDelete = (data: any) => {
    dispatch(websites.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/delete`,
      entity: 'websites',
      jsonData: {
        Records: [
          {
            "Context": {},
            "Message": { Id: data?.Id }

          }
        ]
      }
    })).then(() => {
      // toast.info('Deleted websites successfully')
      dispatch(websites.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          "Filters": [
            {
              "FieldName": "TenantId",
              "FilterOperatorId": 1,
              "FieldValue": tenantId,
              "FieldType": "number"
            }
          ],

        }
      }))
    });
  }

  const fetchTenantWebsites = () => {
    dispatch(websites.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Filters": [
          {
            "FieldName": "TenantId",
            "FilterOperatorId": 1,
            "FieldValue": tenantId,
            "FieldType": "number"
          }
        ],

      }
    }))
  }
  useEffect(() => {
    createColumnDefs()
    fetchTenantWebsites()
  }, [pageData, pageSize])
  const handleAdd = () => {
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      name: 'Add Website',
      callback: () => handleAdd(),
    },

  ];

  return (
    <>
      {websitesItems?.isLoading ? <PageLoader />
        :
        <Table columnData={columnDefs} rowData={websitesItems?.result?.items} setPageData={setPageData}
          handlereset={handlereset} handleEnableTenantWebsite={handleEnableTenantWebsite} handleInputChange={handleInputChange} handleUpdateTenantWebsite={handleUpdateWebsite} paginationData={websitesItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} headingName="Websites"
          handlePublishTenantWebsite={handlePublishTenantWebsite} additionButtons={additionButtons} IsWebsites={true} handleSave={handleSave}
          handleCDNUpdateWebsite={handleCDNUpdateWebsite} handleCDNReset={handleCDNResetWebsite}
          handleCDNDelete={handleCDNDeleteWebsite} setPageSize={setPageSize} />
      }
    </>
  );
}

export default ManagementWebsites;
